<template>
  <div class="roleform">
    <el-form size="mini" :model="form" :rules="rules" ref="roleForm" class="prepend-equal" label-width="110px">
      <el-form-item prop="name" class="required" label="角色名">
        <el-input placeholder="请填写" v-model="form.name" :disabled="isShow"></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input
          placeholder="请填写"
          v-model="form.remark"
          type="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 2, maxRows: 4 }"
          :class="form.remark ? '' : 'required-input'"
          :disabled="isShow"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="运维APP权限">
        <el-checkbox-group class="app-auth-list" v-model="appAuth">
          <el-checkbox v-for="item in appAuthList" :key="item.id" class="auth-item" :label="item.id" :disabled="isShow">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="个人中心权限">
        <el-checkbox-group class="person-center-auth-list" v-model="personCenterAuth">
          <el-checkbox v-for="item in personCenterAuthList" :key="item.id" class="auth-item" :label="item.id" :disabled="isShow">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="权限列表">
        <el-table class="role-table" :data="permissions" row-key="id" border default-expand-all stripe :tree-props="tableTreeProp">
          <el-table-column prop="name" label="菜单名" min-width="120" align="left">
            <template #default="scope">
              <el-checkbox
                class="tree-checkbox"
                v-if="scope.row.permsChildren"
                :disabled="isShow || isDevOps"
                :indeterminate="checkListStatus[scope.row.id].indeterminate"
                v-model="checkListStatus[scope.row.id].isChecked"
                @change="checkboxIndeter(scope.row.id, scope.row.permsChildren)">{{ scope.row.name }}</el-checkbox>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="permName" label="权限名" min-width="220" align="left">
            <template #default="scope">
              <el-checkbox-group v-model="checkList[scope.row.id]" @change="checkboxSync(scope.row.id, scope.row.permsChildren)">
                <el-checkbox class="table-checkbox" v-for="item in scope.row.permsChildren" :key="item.id" :label="item.id" :disabled="isShow || isDevOps">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div v-if="!isShow" class="text-center">
      <el-button class="submit-btn" :loading="submitLoading" @click="submitForm">确定</el-button>
      <el-button class="cancel-btn" @click="cancelOper">取消</el-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'roleForm',
  props: {
    operType: {
      type: String,
      default: 'newRole',
    },
    roleInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isInitPanel: false,
      tableTreeProp: { children: 'children', hasChildren: 'hasChildren' },
      checkList: {},
      checkListStatus: {},

      appAuth: [],
      appAuthList: [],
      personCenterAuth: [],
      personCenterAuthList: [],

      role: null,
      form: {
        id: '',
        name: '',
        permissionIds: '',
        remark: '',
      },
      permissionIds: [],
      permissions: [],
      indeterminate: [],
      rules: {
        name: [
          {
            required: true,
            message: '请输入角色名',
            trigger: 'blur',
          },
        ],
      },
      submitLoading: false,
    }
  },
  computed: {
    // 当前是否详情页
    isShow() {
      return this.operType === 'showRole'
    },
    // 是否运维
    isDevOps() {
      return this.roleInfo.id == '1113'
    }
  },
  watch: {
    // 变更操作类型时，重新加载权限列表
    operType() {
      this.initPermission()
    }
  },
  created() {
    this.initPermission()
    this.handleUnusePerm(this.permissions)
    this.specialOper()
  },
  methods: {
    ...mapActions(['fetchData']),
    // 特殊操作
    specialOper() {
      let roomType = this.permissions.filter(item => item.id == 35)
      let storeIndex = this.permissions.findIndex(item => item.id == 4)
      if (roomType.length && storeIndex != -1) {
        let roomTypeIndex = this.permissions.findIndex(item => item.id == 35)
        this.permissions.splice(roomTypeIndex, 1)
        storeIndex = this.permissions.findIndex(item => item.id == 4)
        this.permissions.splice(storeIndex + 1, 0, roomType[0])
      }
    },
    // 去除无用菜单权限
    handleUnusePerm(perms) {
      for (let i = 0; i < perms.length; i++) {
        if (!perms[i].children && !perms[i].permsChildren && perms[i].type == 1) {
          perms.splice(i, 1)
          i--
          continue
        }
        if (perms[i].children) this.handleUnusePerm(perms[i].children)
      }
    },
    // 数据不更新，参考 this.$set
    checkboxSync(id, list) {
      this.checkList = JSON.parse(JSON.stringify(this.checkList))

      let indeterStatus = this.checkIsFullSelect(id, list)
      if (indeterStatus === 1) {
        this.checkListStatus[id].isChecked = true
        this.checkListStatus[id].indeterminate = false
      } else if (indeterStatus === 0) {
        this.checkListStatus[id].isChecked = false
        this.checkListStatus[id].indeterminate = true
      } else if (indeterStatus === -1) {
        this.checkListStatus[id].isChecked = false
        this.checkListStatus[id].indeterminate = false
      }
    },
    // 复选框全选按钮变更，参考 this.$set
    checkboxIndeter(id, list) {
      this.checkListStatus[id].indeterminate = false
      this.checkListStatus = JSON.parse(JSON.stringify(this.checkListStatus))

      let isChecked = this.checkListStatus[id].isChecked
      // 点了全选复选框，那要么全选要么全不选
      if (isChecked) {
        this.checkList[id] = list.map(item => item.id)
      } else {
        this.checkList[id] = []
      }
    },
    // 校验是否全选，全选返回 1，全不选返回 -1，选了但没选全返回 0
    checkIsFullSelect(id, list) {
      list = list || []
      let clen = this.checkList[id].length
      let plen = list.length

      if (clen === 0) return -1
      if (clen === plen) return 1
      return 0
    },
    // 获取table 树结构
    getTableTree(data) {
      let extraList = []
      data.forEach(item => {
        if (item.id == 1 && !this.isInitPanel) {
          let temp = JSON.parse(JSON.stringify(item))
          temp.parentId = item.id
          this.isInitPanel = true
          item.permsChildren = [temp]
          this.checkList[item.id] = []
          this.checkListStatus[item.id] = {
            indeterminate: false,
            isChecked: false
          }
          return
        }

        if (item.children) {
          let list = []
          let perms = []
          for (let i = 0; i < item.children.length; i++) {
            if (item.children[i].type == 2) {
              perms.push(item.children[i])
            }
            if (item.children[i].type == 1) {
              list.push(item.children[i])
            }
          }
          if (perms.length) {
            item.permsChildren = perms
            delete item.children
            this.checkList[item.id] = []
            this.checkListStatus[item.id] = {
              indeterminate: false,
              isChecked: false
            }
            // 有权限的同时还有普通的菜单，将这些菜单的等级上升一级
            if (list.length) {
              extraList.push(...list)
            }
          } else {
            // 没有权限则按照普通菜单处理
            item.children = this.getTableTree(item.children)
          }
        }
      })

      if (extraList.length) {
        data.push(...extraList)
        data = this.getTableTree(data)
      }

      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
      }

      return data
    },
    // 初始化权限
    initPermission() {
      if (this.isShow) {
        let menuOri = localStorage.getItem('allPerms') ? JSON.parse(localStorage.getItem('allPerms')) : ''
        if (menuOri) {
          let menu = JSON.parse(JSON.stringify(menuOri))
          let menuSec = JSON.parse(JSON.stringify(menuOri))

          this.setFormPermission(menu, menuSec)
        } else {
          let url = 'ROLE.POST_ALL_PERMISSION'
          this.fetchData({ url, method: 'post' }).then((res) => {
            menuOri = res?.data || []
            let menu = JSON.parse(JSON.stringify(menuOri))
            let menuSec = JSON.parse(JSON.stringify(menuOri))

            localStorage.setItem('allPerms', JSON.stringify(menuOri))
            this.setFormPermission(menu, menuSec)
          })
        }
      } else {
        let menuOri = localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : []
        let menu = JSON.parse(JSON.stringify(menuOri))
        let menuSec = JSON.parse(JSON.stringify(menuOri))

        this.setFormPermission(menu, menuSec)
      }
    },
    // 设置表单权限列表
    setFormPermission(menu, menuSec) {
      let list = this.getTableTree(menu)
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == 114 || list[i].id == 115) {
          list.splice(i, 1)
          i--
        }
      }
      this.permissions = list

      // 运维APP权限和个人中心权限
      let appList = menuSec.filter(item => item.id == 115)
      this.appAuthList = appList.length ? appList[0].children : []
      let pcList = menuSec.filter(item => item.id == 114)
      this.personCenterAuthList = pcList.length ? pcList[0].children : []

      if (this.operType === 'editRole' || this.operType === 'showRole') {
        this.role = this.roleInfo
        this.buildFormData()
      } else {
        //个人工作台默认选中
        this.permissionIds.push(22)
      }
    },
    // 提交表单
    submitForm() {
      this.$refs.roleForm.validate((valid) => {
        if (valid) {
          let url = 'ROLE.POST_ADD_OR_UPDATE'
          let permissionIdsArr = []
          for (let i in this.checkList) {
            permissionIdsArr.push(...this.checkList[i])
          }

          permissionIdsArr = permissionIdsArr.concat(this.appAuth)
          permissionIdsArr = permissionIdsArr.concat(this.personCenterAuth)

          let parentIdSet = new Set()
          if (this.appAuth.length) parentIdSet.add('115')
          if (this.personCenterAuth.length) parentIdSet.add('114')
          permissionIdsArr.forEach(item => {
            let parentId = this.getPermPid(item, this.permissions)
            if (parentId) parentIdSet.add(parentId)
          })
          permissionIdsArr.push(...parentIdSet)
          
          // 临时操作 ======================
          permissionIdsArr.forEach(item => {
            let parentId = this.getPermPid(item, this.permissions)
            if (parentId) parentIdSet.add(parentId)
          })
          permissionIdsArr.push(...parentIdSet)
          permissionIdsArr = [...(new Set(permissionIdsArr))]
          // ======================

          permissionIdsArr.sort((a, b) => a - b)

          this.form.permissionIds = permissionIdsArr
          let params = {
            name: this.form.name,
            remark: this.form.remark,
            permissionIds: permissionIdsArr,
          }
          if (this.roleInfo.id) {
            params.id = this.roleInfo.id
          }

          this.submitLoading = true
          this.fetchData({
            url,
            method: 'post',
            params,
            headers: { 'Content-Type': 'application/json' }
          })
            .then((res) => {
              res = res || {}
              if (res.success) {
                this.submitSuccess(this.operType, res)
              } else {
                this.submitFailure(res.msg)
              }
            })
            .catch((err) => {
              this.submitFailure(err)
            })
        } else {
          this.$message.error('信息填写有误，请检查后重新提交')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.roleForm.resetFields()
      this.initPermission()
      this.buildFormData()
    },
    // 取消操作，关闭弹框
    cancelOper() {
      this.$emit('cancel')
    },
    submitFailure(err) {
      this.submitLoading = false
      this.$message.error(err)
    },
    submitSuccess(type, res) {
      this.submitLoading = false
      if (type === 'newRole') {
        this.$message.success('新建角色成功！')
      } else {
        this.$message.success('编辑角色成功！')
      }
      this.$emit('reload')
    },
    // 构建表单数据
    buildFormData() {
      this.appAuth = []
      this.personCenterAuth = []
      this.permissionIds = [...this.role.permissionIds]
      this.form = {
        id: this.role.id || '',
        name: this.role.name || '',
        remark: this.role.remark || '',
        permissionIds: this.role.permissionIds || []
      }

      this.permissionIds.forEach(item => {
        let whichList = 1 // 1-正常列表  2-运维app列表  3-个人中心列表
        let parentId = this.getPermPid(item, this.permissions)
        if (!parentId) {
          whichList = 2
          parentId = this.getPermPid(item, this.appAuthList, true)
        }
        if (!parentId) {
          whichList = 3
          parentId = this.getPermPid(item, this.personCenterAuthList, true)
        }


        if (parentId !== '') {
          switch(whichList) {
            case 1:
              for (let i in this.checkList) {
                if (i == parentId) {
                  this.checkList[parentId].push(item)
                }
              }
              break
            case 2:
              this.appAuth.push(item)
              break
            case 3:
              this.personCenterAuth.push(item)
              break
          }
        }
      })

      this.checkList = JSON.parse(JSON.stringify(this.checkList))
      this.syncCheckIndeter()
    },
    // 同步下全选复选框
    syncCheckIndeter() {
      for (let i in this.checkList) {
        let clen = this.checkList[i].length
        let parent = this.getParentPerm(i, this.permissions) || {}
        let plen = parent.permsChildren ? parent.permsChildren.length : 0

        if (plen) {
          if (clen == plen) {
            this.checkListStatus[i].isChecked = true
            this.checkListStatus[i].indeterminate = false
          } else if (clen == 0) {
            this.checkListStatus[i].isChecked = false
            this.checkListStatus[i].indeterminate = false
          } else {
            this.checkListStatus[i].isChecked = false
            this.checkListStatus[i].indeterminate = true
          }
        }
      }

      this.checkListStatus = JSON.parse(JSON.stringify(this.checkListStatus))
    },
    // 获取权限pid
    getPermPid(id, list, others) {
      if (id == 1) return id

      if (others) {
        for (let i = 0; i < list.length; i++) {
          if (id == list[i].id) {
            return list[i].parentId
          }
        }
        return ''
      }

      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          return list[i].parentId
        }
        if (list[i].children) {
          let parentId = this.getPermPid(id, list[i].children)
          if (parentId) return parentId
        }
        if (list[i].permsChildren) {
          for (let j = 0; j < list[i].permsChildren.length; j++) {
            if (id == list[i].permsChildren[j].id) {
              return list[i].permsChildren[j].parentId
            }
          }
        }
      }

      return ''
    },
    // 获取权限的父节点
    getParentPerm(id, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) return list[i]
        if (list[i].children && list[i].children.length) {
          let res = this.getParentPerm(id, list[i].children)
          if (res) return res
        }
      }

      return ''
    },
  },
}
</script>
<style lang="less" scoped>
.roleform {
  .prepend-equal {
    height: calc(~"100% - 60px");
    overflow-y: auto;
    margin-bottom: 20px;
  }
  .role-table {
    width: 100%;
    margin-bottom: 20px;
    /deep/ .table-checkbox.el-checkbox {
      margin-right: 20px;
    }
    /deep/ .el-table__row td {
      text-align: left;
    }
    /deep/ .tree-checkbox.el-checkbox {
      margin-left: 35px !important;
    }
  }
  .el-input /deep/.el-input__inner{
    border-color:#ccc;
  }
  .el-form-item.is-error.required .el-input /deep/.el-input__inner{
    border-color:#f56c6c !important;
  }
}
.app-auth-list, .person-center-auth-list {
  /deep/ .auth-item {
    margin-right: 25px;
  }
}
.bottom-btn {
  margin: 0px 10px;
}
</style>
<style lang="less">
.roleform {
  height: calc(~"80vh - 140px");
}
span.el-input-group__prepend.label-prepend.m-r-sm.role-form-desc-label {
  margin-right: 0 !important;
  width: 105px !important;
}
</style>
